import { NgComponentOutlet } from '@angular/common';
import {
  afterNextRender,
  Component,
  ElementRef,
  HostListener,
  inject,
  input,
  viewChild,
} from '@angular/core';
import { SidePanelInstance, SidePanelService } from '@services/side-panel.service';

@Component({
  imports: [NgComponentOutlet],
  selector: 'app-side-panel-wrapper',
  styleUrl: './side-panel-wrapper.component.scss',
  templateUrl: './side-panel-wrapper.component.html',
})
export class SidePanelWrapperComponent {
  readonly sidePanel = input.required<SidePanelInstance>();
  private readonly panel = viewChild.required<ElementRef<HTMLElement>>('panel');
  private previouslyFocused: HTMLElement | null = null;
  private sidePanelService = inject(SidePanelService);
  private sidePanels = this.sidePanelService.get();

  constructor() {
    this.previouslyFocused = document.activeElement instanceof HTMLElement ?
      document.activeElement :
      null;

    afterNextRender(() => {
      if (this.sidePanels().at(-1)?.id !== this.sidePanel().id) {
        return;
      }
      this.panel().nativeElement.focus();
    });
  }

  @HostListener('document:keydown.escape')
  protected onEscape(): void {
    if (this.sidePanels().at(-1)?.id === this.sidePanel().id) {
      this.close();
    }
  }

  protected close(): void {
    this.sidePanelService.close(this.sidePanel().id);
    this.previouslyFocused?.focus();
  }
}
